import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { StateLoading } from '../types';
import { axiosInstance } from '../services/axios-instance';
import { errorMessage } from '../utils';

export interface LabResultVerbiage {
  id?: number;
  result: string;
  fromResult?: string;
  name: string;
  value: string;
  createdAt: Date;
  updatedAt: Date;
}

interface LabResultVerbiagesState {
  list: StateLoading<LabResultVerbiage[]>;
  updating: Record<number, boolean>;
}
interface LabResultVerbiagesActions {
  fetchLabResultVerbiage: (params?: {
    name?: string;
    order?: string;
  }) => Promise<void>;
  updateLabResultVerbiage: (body: LabResultVerbiage) => Promise<void>;
  deleteLabResultVerbiage: (body: { id: number }) => Promise<void>;
}

export const useLabResultVerbiages = create<
  LabResultVerbiagesState & LabResultVerbiagesActions
>()(
  devtools(
    persist(
      set => ({
        list: { data: [] },
        updating: {},
        updateLabResultVerbiage: async body => {
          const { id, ...restBody } = body;
          set(state => ({
            updating: { ...state.updating, [id || 'create']: true },
          }));
          try {
            await axiosInstance({
              url: `/lab-results/verbiages/${id || ''}`,
              method: id ? 'PATCH' : 'POST',
              data: restBody,
            });
          } catch (err) {
            console.log(errorMessage(err));
          }
          set(state => ({
            updating: { ...state.updating, [id || 'create']: false },
          }));
        },
        fetchLabResultVerbiage: async params => {
          set({ list: { isLoading: true } });
          try {
            const { data } = await axiosInstance('/lab-results/verbiages', {
              params: { order: '-id', ...params },
            });
            set({ list: { data } });
          } catch (err) {
            set({ list: { error: errorMessage(err) } });
          }
        },
        deleteLabResultVerbiage: async ({ id }) => {
          const confirm = window.confirm(
            'Are you sure you want to delete this item?',
          );
          if (!confirm) {
            return;
          }
          set(state => ({
            updating: { ...state.updating, [id || 'create']: true },
          }));
          try {
            await axiosInstance({
              url: `/lab-results/verbiages/${id || ''}`,
              method: 'DELETE',
            });
          } catch (err) {
            console.log(errorMessage(err));
          }
          set(state => ({
            updating: { ...state.updating, [id || 'create']: false },
          }));
        },
      }),
      { name: 'lab-result-verbiages-storage' },
    ),
  ),
);
